export default __webpack_public_path__ + "static/media/picto-cadastral_geometrico.f904e308.svg";